import React from 'react'

import './titulo.css'

export const Titulo = ({ children }) => {
  return <h1 className="titulo">{children}</h1>
}
